import { GridProps, GridSpacing } from '@material-ui/core/Grid';
import Grid from '@material-ui/core/Grid';
import classNames from 'classnames';
import React from 'react';
import { Maybe } from '../../Shared/Types';
import styles from './FormGrid.module.scss';

type FormGridProps = GridProps & {
    maxWidth?: number;
    full?: boolean;
    input?: boolean;
    half?: boolean;
    third?: boolean;
    fourth?: boolean;
    fifth?: boolean;
    twoFifth?: boolean;
    row?: boolean;
    stretch?: boolean;
    autoWidth?: boolean;
    sectionTitle?: boolean;
    button?: boolean;
    alignCenter?: boolean;
    marginBottom?: number;
    spacing?: GridSpacing;
};

export class FormGrid extends React.Component<FormGridProps> {
    public render() {
        const {
            maxWidth,
            marginBottom,
            style,
            full,
            input,
            half,
            third,
            fourth,
            fifth,
            twoFifth,
            alignCenter,
            row,
            sectionTitle,
            stretch,
            autoWidth,
            button,
            className,
            ...otherProps
        } = this.props;

        const inlineStyles = {
            maxWidth,
            marginBottom
        };

        const gridClasses = classNames(styles.formGrid, this.props.className || null, {
            [styles.full]: full,
            [styles.half]: input || half,
            [styles.third]: third,
            [styles.fourth]: fourth,
            [styles.fifth]: fifth,
            [styles.twoFifth]: twoFifth,
            [styles.alignCenter]: alignCenter,
            [styles.sectionTitle]: sectionTitle,
            [styles.button]: button,
            [styles.stretch]: stretch,
            [styles.autoWidth]: autoWidth,
            [styles.hasMaxWidth]: !!maxWidth,
            [styles.input]: input
        });
        let spacing: Maybe<GridSpacing>;

        if (this.props.spacing !== undefined && this.props.container) {
            spacing = this.props.spacing;
        } else if (this.props.container || this.props.row) {
            spacing = 3;
        }

        return (
            <Grid
                {...otherProps}
                spacing={spacing}
                item={!(this.props.container || this.props.row)}
                container={this.props.container || this.props.row ? true : undefined}
                xs={input ? 12 : this.props.xs}
                className={gridClasses}
                style={inlineStyles}
            >
                {this.props.children}
            </Grid>
        );
    }
}
